import { render, staticRenderFns } from "./SuppliersActions.vue?vue&type=template&id=b2e8a200&scoped=true&"
import script from "./SuppliersActions.vue?vue&type=script&lang=js&"
export * from "./SuppliersActions.vue?vue&type=script&lang=js&"
import style0 from "./SuppliersActions.vue?vue&type=style&index=0&id=b2e8a200&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2e8a200",
  null
  
)

export default component.exports